import { render } from "./dlg-box.vue?vue&type=template&id=6326b4ce"
import script from "./dlg-box.vue?vue&type=script&lang=js"
export * from "./dlg-box.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__